import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 0 20px;
`;

export const FormInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 14px;
  padding: 0 15px;
  height: 52px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  transition: border-color 0.2s ease-in-out;

  &:focus-within {
    border-color: ${({ theme }) => theme.palette.brand.main};
  }
`;

export const Description = styled(Typography.Caption).attrs(() => ({
  $variant: '1',
}))`
  font-size: 16px;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 15px;
    text-align: unset;
  }
`;
